<template>
    <v-app>
        <v-main class="login">
            <!-- <Notification @hide="togglenotif" :info="notif.info" :title="notif.title" :msg="notif.msg" :filled="notif.filled" :success="notif.success" :error="notif.error" :warning="notif.warning" :active="notif.active"/>-->
            <v-container class="form-container">
                <v-row>
                    <v-col class="image-container">
                        <logo-login />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <login-form />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <p class="copyright-text small-body">
                            {{ $t('login.recaptcha_warning') }}.<br/>
                            {{ $t('login.copyright', {year: currentYear}) }}.
                        </p>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
import LoginForm from "../../Shared/Form/LoginForm.vue";
import LogoLogin from "../../Shared/ImagesSVG/LogoLogin.vue";
import dayjs from "dayjs";
//import Notification from "../../Shared/Notification.vue";

export default {
    components: {
        LoginForm,
        LogoLogin,
        //Notification,
    },

    data: () => ({
        currentYear: dayjs().format('YYYY'),
    }),
};
</script>
